import { Month } from '../../view/admin/getEstimationMonths';

type Estimations = MonthEstimation[];

export default Estimations;

export interface MonthEstimation {
    month: Month;
    articlesEstimations: ArticleEstimation[];
    id: string;
}

export interface ItemEstimation {
    sku: string;
    variantCode: string;
    value: number;
}

export interface ArticleEstimation {
    articleId: string;
    wholesalePrice: number;
    discountedPrice: number;
    itemsEstimations: ItemEstimation[];
}

export const getEstimationForSku = (articlesEstimations: EstimationMonthSum, articleId: string, sku: string): number => {
    const articleEstimations: EstimationItemMonthSum | undefined = articlesEstimations[articleId];
    if (!articleEstimations) {
        return 0;
    }
    return articleEstimations[sku] || 0;
};

export const getEstimationForMonthArticleAndSku = (estimations: Estimations, articleId: string, sku: string, month: Month): number => {
    if (getEstimation(estimations, month)) {
        const product = getEstimation(estimations, month)!.articlesEstimations.find(
            (estimation: ArticleEstimation) => articleId === estimation.articleId
        );
        if (product) {
            const foundEstimation = product.itemsEstimations.find(x => x.sku === sku);
            return foundEstimation ? foundEstimation.value : 0;
        }
        return 0;
    }
    return 0;
};

export const getEstimation = (estimations: Estimations, month: Month): MonthEstimation | undefined =>
    estimations.find(
        (monthEstimation: MonthEstimation) => monthEstimation.month.month === month.month && monthEstimation.month.year === month.year
    );

export const getArticlesEstimations = (estimations: Estimations, month: Month): ArticleEstimation[] =>
    getEstimation(estimations, month) ? getEstimation(estimations, month)!.articlesEstimations : [];

export const isSameMonth = (month1: Month, month2: Month): boolean => month1.month === month2.month && month1.year === month2.year;

export interface EstimationMonthSum {
    [articleId: string]: EstimationItemMonthSum;
}

export interface EstimationItemMonthSum {
    [sku: string]: number;
}



// WEBPACK FOOTER //
// ./src/domain/estimations/Estimations.ts